import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from "src/app/Service/axios";
declare let $: any;

@Component({
  selector: 'app-tanker-drivers-risk-ranking',
  templateUrl: './tanker-drivers-risk-ranking.component.html',
  styleUrls: ['./tanker-drivers-risk-ranking.component.css']
})

export class TankerDriversRiskRankingComponent implements OnInit {

  data: any = [];
  searchList = [];

  searchForm: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    strSDate: new FormControl(''),
    strEDate: new FormControl(''),
  })

  constructor(
    private otherService: OtherService,
    private FormBuilder: FormBuilder,
    private router: Router, private gurdService: GurdServiceService,
    private Notification: NotificationService
  ) { }

  ngOnInit(): void {

  }

  filterResult(strValue: string) {
    if (strValue.length > 1) {
      this.data = this.searchList.filter((el: any) => {
        return (
          el.strFullName.includes(strValue) ||
          el?.strMobile.includes(strValue) ||
          el?.strMobileDomain_strComment.includes(strValue) ||
          el?.strVehicleNo.includes(strValue)
        );
      });
    } else if (strValue == '') {
      this.data = this.searchList;
    }
  }

  fetchData = async () => {
    let model = this.searchForm.value;
    this.otherService.Showspinner();
    let res = JSON.parse((await axios.post(`Tanker_Report_Feeding_HighRiskDrivers`, model)).data.toString());
    this.otherService.nonespinner();

    if (res.ISSessionExpired == true) {
      this.Notification.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'xxz12z110' } });
      return;
    }

    if (res.iResult == 0) {
      return this.Notification.showError(res.strError);
    }

    this.data = this.searchList = res;

  };

  getTrustScoreClass(score: number): string {
    if (score >= 90) {
      return 'row-trust-excellent';
    }

    if (score >= 75) {
      return 'row-trust-good';
    }

    if (score >= 50) {
      return 'row-trust-warning';
    }

    return 'row-trust-danger';
  }

}